import { EnvEnum, Environment } from 'editor/src/environment/types';

const env: Environment = {
  production: false,
  env: EnvEnum.staging,
  translationsUrl: 'https://design-editor.staging.gelato.tech/translations/',
  useLokalino: true,
  amplitudeKey: '',
  shutterstockKeys: {
    essentials: 'G1PTOJzNrrvaESrDlGCeGrGpu7XdSICQ',
    full: 'nNJwspGEM8GtBdqnU2FyGk1Qcr8fQXf0',
  },
  datadogClientToken: '',
};

export default env;
